import React, { useState, useEffect, Fragment, useRef } from 'react'
import axios from "axios";
import {
    Table,
    Button, Row, Col,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import useSound from 'use-sound';
import swiftly from '../../assets/sound/swiftly.mp3'

import './Orders.css'
import { data } from 'jquery';
const PendingOrders = () => {
    const [orderDetails, setOrderDetails] = useState([])
    const [pendingOrderDetails, setPendingOrderDetails] = useState([])
    
    const [loading, setloading] = useState(true)
    const [itemsModel, setModal] = useState(false);
    const [dispatchModal, setDispatchModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [confirmModel, setConfirmModel] = useState(false);
    const [dataItem, setDataItem] = useState([])
    const [dataDispatch, setDataDispatch] = useState([])
    const [orderCount, setOrderCount] = useState(0)
    //Timer Tick
    const [count, setCount] = useState(0);
    const [play] = useSound(swiftly);

    const tick = () => {
        //let newCount = count < 60 ? count + 1 : 0
        setCount((prevState) => prevState < 1200 ? prevState + 1 : 0);
    }
    useEffect(() => {
        const timer = setInterval(() => tick(), 100);
        return () => clearInterval(timer);
    });


    const toggleItems = (data) => {
        console.log("toggleItems -> data", data)
        setDataItem(data);
        setModal(!itemsModel);
    }
    const toggleDispatch = (data) => {
        console.log("toggleDispatch -> data", data)
        setDataDispatch(data);
        setDispatchModal(!dispatchModal);
    }
    const toggleDelete = (data) => {
        console.log("toggleDelete -> data", data)
        setDataDispatch(data);
        setDeleteModal(!deleteModal);
    }
    const printReceipt = () => {
        var divContents = document.getElementById("print").innerHTML;
        var a = window.open('', '', 'height=500, width=500');
        a.document.write('<html>');
        a.document.write('<body style="width:300px" >');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }


    const onClickConfirm = (data) => {
        setloading(true);
        const access = sessionStorage.getItem('access');
        // setConfirmModel(!confirmModel);
        let url = `https://api.chicking-malappuram.in/api/orders/${data.id}/`;
        axios({
            method: 'patch',
            url: url,
            data: { "status": "confirmed" },
            headers: { 'Authorization': `Bearer ${access}` }
        }).then(res => {
            console.log("onClickConfirm -> res", res)
            if (res.data === 'success') {
                getOrderList();
            }
            setloading(false);
        });
    }

 
    const onClickDispatch= (data) => {
        setloading(true);
        const access = sessionStorage.getItem('access');
        // setConfirmModel(!confirmModel);
        let url = `https://api.chicking-malappuram.in/api/orders/${data.id}/`;
        axios({
            method: 'patch',
            url: url,
            data: { "status": "dispatched" },
            headers: { 'Authorization': `Bearer ${access}` }
        }).then(res => {
            console.log("onClickConfirm -> res", res)
            if (res.data === 'success') {
                getOrderList();
            }
            setloading(false);
        });
        setDispatchModal(!dispatchModal);
    }
    const onClickDelete= (data) => {
        // setloading(true);
        if (localStorage.getItem("userType")==='admin'){         
            const access = sessionStorage.getItem('access');
            let url = `https://api.chicking-malappuram.in/api/orders/${data.id}/`;
            axios({
                method: 'patch',
                url: url,
                data: { "status": "deleted" },
                headers: { 'Authorization': `Bearer ${access}` }
            }).then(res => {
                console.log("onClickConfirm -> res", res)
                if (res.data === 'success') {
                    getOrderList();
                }
                setloading(false);
            });
            setDeleteModal(!deleteModal);
        }
        else{
            alert("You don't have the permission")
        }
    }
    let textInput = React.createRef();
    function handleClick() {
        //   alert(textInput.current.value);
          const access = sessionStorage.getItem('access');
            axios({
                method: 'get',
                url: `https://api.chicking-malappuram.in/api/orders/?status=pending&phone=${textInput.current.value}`,
                headers: { 'Authorization': `Bearer ${access}` }
            }).then((res) => {
                console.log("res", res)
                if (res.data.length > 0) {
                    setOrderDetails(res.data);
                }
                setloading(false)
                
            });
        }
    const getOrderList = () => {
        const access = sessionStorage.getItem('access');
        axios({
            method: 'get',
            url: 'https://api.chicking-malappuram.in/api/orders/?status=pending',
            headers: { 'Authorization': `Bearer ${access}` }
        }).then((res) => {
            console.log("res", res)
           
            setOrderDetails(res.data);
            setloading(false);
           
            setOrderCount(res.data.length);

        });
        axios({
            method: 'get',
            url: 'https://api.chicking-malappuram.in/api/orders/?status=confirmed',
            headers: { 'Authorization': `Bearer ${access}` }
        }).then((res) => {
            console.log("res", res)
           
            setPendingOrderDetails(res.data);
            setloading(false);
           
           

        });
    }
    if (count === 0) {

        getOrderList();

    }
    useEffect(() => {

        if (count === 0) {

            getOrderList();

        }

    }, count);



    return (
        <Fragment>
            <div className="content">
                <Row>
                    <Col lg="12">
                        <div className="card chicking-card">
                        <div style={{width:"fit-content"}}className="pull-left">
                            <input ref={textInput} style={{padding:6,marginRight:5}} name="search" placeholder="search"></input>
                            <Button onClick={handleClick}>Search</Button>
                            </div>
                            <Table striped>
                                <thead>
                                    <tr>
                                        {/* <th>Order Id</th> */}
                                        <th>Customer NAME</th>
                                        <th>Contact No</th>
                                        {/* <th>Address</th> */}
                                        <th>Outlet</th>
                                        <th>Order Type</th>
                                        <th>Total Amount</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? 'Loading...' : ''}
                                    {orderDetails && orderDetails.length > 0 &&                                        
                                        orderDetails.map((data, index) =>
                                            <tr className="pending">
                                                {/* <td>{data.id}</td> */}
                                                <td>{data.name}</td>
                                                <td>{data.number}</td>
                                                {/* <td>{data.address}</td> */}
                                                <td>{data.outlet}</td>
                                                <td>{data.order_type}</td>
                                                <td><p className="total">{`Rs. ${data.total}`}</p></td>
                                                <td>{data.status}</td>
                                                <td> {data.status === 'pending' ? <Button color="primary" onClick={() => onClickConfirm(data)}>Confirm</Button> : ''}</td>
                                                <td><Button color="warning" onClick={() => toggleItems(data)}>Details</Button></td>
                                                <td><Button color="danger" onClick={() => toggleDelete(data)}>Delete</Button></td>
                                            </tr>
                                        )}
                                        {pendingOrderDetails && pendingOrderDetails.length > 0 &&
                                            pendingOrderDetails.map((data, index) =>
                                            <tr className="confirmed">
                                                {/* <td>{data.id}</td> */}
                                                <td>{data.name}</td>
                                                <td>{data.number}</td>
                                                {/* <td>{data.address}</td> */}
                                                <td>{data.outlet}</td>
                                                <td>{data.order_type}</td>
                                                <td><p className="total">{`Rs. ${data.total}`}</p></td>
                                                <td>{data.status}</td>
                                                <td> {data.status==='confirmed'?<Button color="success" onClick={() => toggleDispatch(data)}>Dispatch</Button>:''}</td>
                                                <td><Button color="warning" onClick={() => toggleItems(data)}>Details</Button></td>
                                                <td><Button color="danger" onClick={() => toggleDelete(data)}>Delete</Button></td>
                                            </tr>
                                        )}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* confirm modal */}
            {/* <Modal isOpen={confirmModel} toggle={toggleConfirm}>
                <ModalHeader toggle={toggleConfirm}>View Order Items</ModalHeader>
                <ModalBody>
                    <Table striped>
                        <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataItem && dataItem.length > 0 &&
                                dataItem.map((data, index) =>
                                    <tr>
                                        <td>{data.item}</td>
                                        <td>{data.qty}</td>
                                    </tr>
                                )}
                        </tbody>
                    </Table>
                </ModalBody>


            </Modal> */}


            {/* items Model */}
            <Modal isOpen={itemsModel} toggle={toggleItems}>
                <ModalHeader toggle={toggleItems}>View Order Items</ModalHeader>
                <ModalBody>
                    <Table striped>
                        <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>Quantity</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataItem.items && dataItem.items.length > 0 &&
                                dataItem.items.map((data, index) =>
                                    <tr>
                                        <td>{data.item}</td>
                                        <td>{data.qty}</td>
                                        <td>{data.remarks}</td>
                                    </tr>
                                )}
                        </tbody>
                    </Table>
                    <h6>Order taken by : {dataItem.staff}</h6>
                    <div className="address-box">
                    <h6>Order Id :{dataItem.id} </h6>
                    <h6>Outlet :{dataItem.outlet} </h6>
                    <h4>Customer Details:</h4>
                        <h6>{dataItem.name}</h6>
                        <h6>{dataItem.number}</h6>
                        <p>{dataItem.address}</p>
                        {/* <h5>Notes:</h5>
                        <p>{dataItem.notes}</p> */}
                            <h6>Ordered on : {dataItem.time}</h6>
                        <h6>confirmed at : {dataItem.confirmed_time}</h6>
                    </div>
                    <div id="print">
                        <h4 style={{textAlign:"center"}}className="text-center">chicking {dataItem.outlet}</h4>
                        <hr />
                        <p style={{textAlign:"center"}}className="text-center">{dataItem.confirmed_time}</p>
                        <hr />
                        <span style={{width:"100%", display:"block"}}><b>Name: </b>{dataItem.name}</span>
                        <span style={{width:"100%", display:"block"}}><b>Address: </b>{dataItem.address}</span>
                        <span style={{width:"100%", display:"block"}}><b>phone: {dataItem.number}</b></span>
                        <hr />
                        <h4 style={{textAlign:"center"}}className="text-center">Order</h4>
                        <table className="table">
                        {dataItem.items && dataItem.items.length > 0 &&
                                dataItem.items.map((data, index) =>
                                    <tr>
                                        <td><b>{data.qty}</b> X {data.item} </td>
                                        <td>{data.remarks}</td>
                                    </tr>
                                )}
                        </table>
                        <hr />
                        <h4>Thank you</h4>
                    </div>
                    <Button color="danger" onClick={() => printReceipt()}>Print</Button>
                </ModalBody>


            </Modal>
            <Modal isOpen={dispatchModal} toggle={toggleDispatch}>
                <ModalHeader toggle={toggleDispatch}>Confirm Dispatch</ModalHeader>
                <ModalBody>
                <Button color="primary" onClick={() => onClickDispatch(dataDispatch)}>Dispatch</Button>
                </ModalBody>
            </Modal>
            <Modal isOpen={deleteModal} toggle={toggleDelete}>
                <ModalHeader toggle={toggleDelete}>Confirm Delete</ModalHeader>
                <ModalBody>
                <Button color="primary" onClick={() => onClickDelete(dataDispatch)}>Delete</Button>
                </ModalBody>
            </Modal>
        </Fragment>
    )
}


export default PendingOrders
